const QUEUE_KEY = 'ficharbot_offline_queue_v1';

export interface QueuedFichaje {
  queueId: string;
  timestamp: number;
  /** Datos listos para enviar a ficharService.inserRecord */
  data: Record<string, any>;
}

export function getQueue(): QueuedFichaje[] {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function addToQueue(data: Record<string, any>): QueuedFichaje {
  const item: QueuedFichaje = {
    queueId: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    timestamp: Date.now(),
    data,
  };
  const queue = getQueue();
  queue.push(item);
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  return item;
}

export function removeFromQueue(queueId: string): void {
  const queue = getQueue().filter((item) => item.queueId !== queueId);
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

export function getQueueCount(): number {
  return getQueue().length;
}
